import { render, staticRenderFns } from "./PointMessage.vue?vue&type=template&id=6aea59a1&scoped=true"
import script from "./PointMessage.vue?vue&type=script&lang=js"
export * from "./PointMessage.vue?vue&type=script&lang=js"
import style0 from "./PointMessage.vue?vue&type=style&index=0&id=6aea59a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aea59a1",
  null
  
)

export default component.exports